module.exports = __webpack_public_path__ + "4653603871bd0bbbc7944208991f1180.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_cow.png
// module id = 55
// module chunks = 0